import { Avatar, Box, Tooltip, Typography, useMediaQuery, useTheme } from '@mui/material'
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'
import get from 'lodash/get'
import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next'
import { setSelectedStudent } from 'store/academic/parent/parent-student';
import { useDispatch, useSelector } from 'react-redux';
import { setStudent as addStudentInfoToSession } from '../store/session'

const ParentStudents = ({ studentList, location, MenuItem }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const theme = useTheme();
  const { t } = useTranslation();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const [selectedStudentId, setSelectedStudentId] = useState(studentList?.[0]?.personAccessViews[0]?.id ?? null);
  const studentId = useSelector(state => state.academic.parentStudent?.selectedStudent?.personAccessViews[0]?.id)
  const sessionStudentId = useSelector(state => state.session.studentMemberId)
  const person = useSelector(state => state.session.person)

  const handleMenuClick = (studentId) => {
    setSelectedStudentId((prevId) => {
      const isSame = prevId === studentId;
      if (!isSame) {
        const selectedStudent = studentList.find(student => student.personAccessViews[0]?.id === studentId);
        dispatch(setSelectedStudent(selectedStudent));

        navigate('/');
      }
      return isSame ? null : studentId;
    });
  };

    useEffect(() => {
      if (!studentId || sessionStudentId === studentId) return

      const student = studentList?.find(student => student?.personAccessViews[0]?.id === studentId)
      if (student) {
        dispatch(addStudentInfoToSession({ memberId: studentId }));
      }
    }, [studentId, sessionStudentId, studentList?.length, person.id]);

  const showAllStudents = selectedStudentId === null;
  const hasMultiple = studentList?.length > 1;
  const visibleStudents = showAllStudents
    ? studentList
    : studentList.filter(s => s.personAccessViews[0]?.id === selectedStudentId);

  return (
    <>

      {visibleStudents.map((student) => {
        const isActive = student.personAccessViews[0]?.id === studentId;
        const page = {
          title: [student.firstName, student.lastName].join(' '),
          icon: (
            <Avatar sx={{ width: 32, height: 32 }} src={get(student, 'profilePicture.location')}>
              {[student.firstName[0], student.lastName[0]].join('')}
            </Avatar>
          ),
        };

        const item = (
          <Box onClick={() => handleMenuClick(student.personAccessViews[0]?.id)}>
            <MenuItem
              page={page}
              location={location}
              isMenuCollapsed={isMobile}
              sx={isActive && hasMultiple ? { bgcolor: 'action.selected', borderRadius: 1 } : undefined}
            />
            {isActive && hasMultiple && !showAllStudents && !isMobile && (
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, justifyContent: 'center', pb: 0.5, }}>
                <KeyboardArrowDownIcon fontSize="small" sx={{ color: 'primary.contrastText' }} />
                <Typography variant="body2" color="primary.contrastText">{t('Switch student')}</Typography>
              </Box>
            )}
          </Box>
        );

        return hasMultiple && !isMobile ? (
          <Tooltip key={student.id} title={t('Click to switch student')} placement="right" arrow>
            {item}
          </Tooltip>
        ) : (
          <Box key={student.id}>{item}</Box>
        );
      })}
    </>
  );
};

export default ParentStudents;
